import { useState } from "react";
import { toast } from "sonner";
import { gestApi } from "../GestAuthContext";
import { categorieCosto } from "./shared";

export default function CostoForm({ cantiereId, onClose, onSaved }) {
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({
    fornitore: "", importo: "", categoria: "profili", data: new Date().toISOString().slice(0, 10),
    tipo_documento: "fattura", numero_documento: "", note: "",
  });
  const update = (k, v) => setForm((s) => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      await gestApi.post("/costi", { ...form, cantiere_id: cantiereId, importo: Number(form.importo) });
      toast.success("Costo aggiunto");
      onSaved();
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <form onSubmit={submit} className="w-full max-w-[560px] bg-white rounded-2xl overflow-hidden shadow-xl" data-testid="gest-costo-form">
        <div className="px-6 py-4 border-b border-black/5 flex items-center justify-between">
          <div className="text-[15px] font-semibold text-[#0a1420]">Nuovo costo</div>
          <button type="button" onClick={onClose} className="text-[#6e6e73] hover:text-[#0a1420] text-[20px] leading-none">×</button>
        </div>
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="md:col-span-2">
            <label className="block text-[12px] text-[#6e6e73] mb-1">Fornitore *</label>
            <input required value={form.fornitore} onChange={(e) => update("fornitore", e.target.value)} data-testid="gest-costo-fornitore" className="w-full border border-black/10 rounded-lg px-3 py-2 text-[14px]" />
          </div>
          <div>
            <label className="block text-[12px] text-[#6e6e73] mb-1">Importo (€) *</label>
            <input required type="number" min="0.01" step="0.01" value={form.importo} onChange={(e) => update("importo", e.target.value)} data-testid="gest-costo-importo" className="w-full border border-black/10 rounded-lg px-3 py-2 text-[14px]" />
          </div>
          <div>
            <label className="block text-[12px] text-[#6e6e73] mb-1">Categoria *</label>
            <select value={form.categoria} onChange={(e) => update("categoria", e.target.value)} data-testid="gest-costo-categoria" className="w-full border border-black/10 rounded-lg px-3 py-2 text-[14px] bg-white">
              {categorieCosto.map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-[12px] text-[#6e6e73] mb-1">Data *</label>
            <input required type="date" value={form.data} onChange={(e) => update("data", e.target.value)} className="w-full border border-black/10 rounded-lg px-3 py-2 text-[14px]" />
          </div>
          <div>
            <label className="block text-[12px] text-[#6e6e73] mb-1">Tipo documento</label>
            <select value={form.tipo_documento} onChange={(e) => update("tipo_documento", e.target.value)} className="w-full border border-black/10 rounded-lg px-3 py-2 text-[14px] bg-white">
              <option value="fattura">Fattura</option>
              <option value="ordine">Ordine</option>
              <option value="ddt">DDT</option>
              <option value="nota_credito">Nota di credito</option>
              <option value="altro">Altro</option>
            </select>
          </div>
          <div className="md:col-span-2">
            <label className="block text-[12px] text-[#6e6e73] mb-1">N° documento</label>
            <input value={form.numero_documento} onChange={(e) => update("numero_documento", e.target.value)} className="w-full border border-black/10 rounded-lg px-3 py-2 text-[14px]" />
          </div>
          <div className="md:col-span-2">
            <label className="block text-[12px] text-[#6e6e73] mb-1">Note</label>
            <textarea rows={2} value={form.note} onChange={(e) => update("note", e.target.value)} className="w-full border border-black/10 rounded-lg px-3 py-2 text-[14px] resize-none" />
          </div>
        </div>
        <div className="px-6 py-4 border-t border-black/5 flex items-center justify-end gap-2">
          <button type="button" onClick={onClose} className="px-4 py-2 text-[13px] text-[#6e6e73]">Annulla</button>
          <button type="submit" disabled={busy} data-testid="gest-costo-save" className="px-5 py-2 bg-[#0a1420] text-white rounded-lg text-[13px] font-semibold disabled:opacity-60">
            {busy ? "Salvataggio…" : "Salva"}
          </button>
        </div>
      </form>
    </div>
  );
}
